import React from "react";
import AddIcon from "@mui/icons-material/Add";
import Controls from "../../../../components/form/controls/Controls";
import useAuth from "../../../../hooks/useAuth";
import { allowedToCreateEntity } from "../../../../constants/role";
import { isOpenPopup } from "src/utils/isOpenPopup";

const DepartmentControlPanel = ({
  permissionsAccessControl,
  handleOpenPopup,
  children,
}) => {
  const { auth } = useAuth();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <Controls.Button
            text="Add New"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => handleOpenPopup(isOpenPopup, null)}
          />
        )}
      </div>
    </div>
  );
};

export default DepartmentControlPanel;
